module.exports = __webpack_public_path__ + "img/symbol_5.5adf6fe3.png";